import { useReducer } from 'react';

type OnboardingState =
  | {
      currentPage: 1 | 3;
    }
  | { currentPage: 2; organisationId: string };

export type OnboardingAction =
  | { type: 'MOVE_TO_PAGE_1' }
  | { type: 'MOVE_TO_PAGE_2'; organisationId: string }
  | { type: 'MOVE_TO_PAGE_3' };

const initialState: OnboardingState = {
  currentPage: 1
};

function onboardingReducer(
  state: OnboardingState,
  action: OnboardingAction
): OnboardingState {
  switch (action.type) {
    case 'MOVE_TO_PAGE_1':
      return { ...state, currentPage: 1 };
    case 'MOVE_TO_PAGE_2':
      return {
        ...state,
        currentPage: 2,
        organisationId: action.organisationId
      };
    case 'MOVE_TO_PAGE_3':
      return { ...state, currentPage: 3 };

    default:
      return state;
  }
}

export function useOnboardingReducer(): [
  OnboardingState,
  React.Dispatch<OnboardingAction>
] {
  const [state, dispatch] = useReducer(onboardingReducer, initialState);
  return [state, dispatch];
}
